
import Button from "@/components/base/Button"

export default {
    name: "RequestLogin",
    components: { Button },
    methods: {
        login() {
            this.$emit("close")
            this.$store.dispatch("account/showAuth")
        },
    },
}
